import { useState } from "react";
import "./CarRentals.css";

export default function CarRentals() {
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    car: "",
    pickupDate: "",
    returnDate: "",
    message: "",
  });

  const whatsappNumber = "+255718665620"; // Muhammed Tours

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();

    const text = `🚗 *Car Booking Request* 🚗
Name: ${form.name}
Email: ${form.email}
Phone: ${form.phone}
Car Model: ${form.car}
Pickup Date: ${form.pickupDate}
Return Date: ${form.returnDate}
Message: ${form.message}`;

    const sanitizedNumber = whatsappNumber.replace(/\D/g, "");
    const url = `https://wa.me/${sanitizedNumber}?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank");

    setForm({
      name: "",
      email: "",
      phone: "",
      car: "",
      pickupDate: "",
      returnDate: "",
      message: "",
    });
    setShowForm(false);
  };

  const selectCar = (carName) => {
    setForm({ ...form, car: carName });
    setShowForm(true);
  };

  return (
    <section className="car-rentals">
      {/* Hero header */}
      <header
  className="hero"
  style={{
    backgroundImage: "url(/images/carrent.webp)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat"
  }}
>

  <h1>CAR RENTALS</h1>
  <p className="tagline">
    Choose from our fleet of self-drive and chauffeured vehicles:
    <strong> Compact cars, SUVs, and vans ready for your trip!</strong>
  </p>
</header>

      {/* Rental Categories */}
      <div className="rental-grid">
        <div className="rental-card">
          <h3>Economy</h3>
          <p>Fuel-efficient cars ideal for solo travelers and couples.</p>
        </div>
        <div className="rental-card">
          <h3>SUV</h3>
          <p>Comfortable SUVs perfect for families and safari transfers.</p>
        </div>
        <div className="rental-card">
          <h3>Minivan</h3>
          <p>Spacious vehicles for groups and luggage-friendly travel.</p>
        </div>
      </div>

      {/* Car Gallery */}
      <section className="gallery">
        <h2><strong>OUR FLEET</strong></h2>
        <div className="gallery-grid">
          <div className="gallery-item" onClick={() => selectCar("TOYOTA RAV4 5 DOORS")}>
            <img src="/images/rava5.jpg" alt="Toyota Rav4" />
            <span className="car-name">TOYOTA RAV4 5 DOORS</span>
          </div>
          <div className="gallery-item" onClick={() => selectCar("TOYOTA RAV4 4 3 DOORS")}>
            <img src="/images/rava3.jpg" alt="Toyota Rav4 3 Doors" />
            <span className="car-name">TOYOTA RAV4 4 3 DOORS</span>
          </div>
          <div className="gallery-item" onClick={() => selectCar("SUZUKI GRAND VITARA")}>
            <img src="/images/suzukivitara.jpg" alt="Suzuki Grand Vitara" />
            <span className="car-name">SUZUKI GRAND VITARA</span>
          </div>
          <div className="gallery-item" onClick={() => selectCar("SUZUKI ESCUDO 5 DOORS")}>
            <img src="/images/suzukiescudo.jpg" alt="Suzuki Escudo" />
            <span className="car-name">SUZUKI ESCUDO 5 DOORS</span>
          </div>
          <div className="gallery-item" onClick={() => selectCar("SUZUKI ESCUDO 3 DOORS")}>
            <img src="/images/suzukiescudo3.jpg" alt="Suzuki Escudo 3 Doors" />
            <span className="car-name">SUZUKI ESCUDO 3 DOORS</span>
          </div>
          <div className="gallery-item" onClick={() => selectCar("TOYOTA NOAH")}>
            <img src="/images/toyotanoah.jpg" alt="Toyota Noah" />
            <span className="car-name">TOYOTA NOAH</span>
          </div>
        </div>
      </section>

      {/* Call-to-Action */}
      <footer className="cta">
        <button className="btn-primary" onClick={() => setShowForm(true)}>
          Book Your Car Now
        </button>
      </footer>

      {/* Booking Form Modal */}
      {showForm && (
        <div className="booking-form-overlay">
          <div className="booking-form">
            <h3>Book Your Car</h3>
            <form onSubmit={onSubmit}>
              <label>Name
                <input name="name" value={form.name} onChange={onChange} required />
              </label>
              <label>Email
                <input type="email" name="email" value={form.email} onChange={onChange} required />
              </label>
              <label>Phone
                <input name="phone" value={form.phone} onChange={onChange} required />
              </label>
              <label>Car Model
                <input name="car" value={form.car} onChange={onChange} required />
              </label>
              <label>Pickup Date
                <input type="date" name="pickupDate" value={form.pickupDate} onChange={onChange} required />
              </label>
              <label>Return Date
                <input type="date" name="returnDate" value={form.returnDate} onChange={onChange} required />
              </label>
              <label>Message
                <textarea name="message" value={form.message} onChange={onChange} rows="4" />
              </label>
              <div className="form-actions">
                <button type="submit" className="btn-primary">Send Booking via WhatsApp</button>
                <button type="button" className="btn-secondary" onClick={() => setShowForm(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </section>
  );
}
